// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_CreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_categorias/create
 *
 * Returns the newly-created expense category id.
 * Wire shape: { despesa_categoria_id: <int> }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DespesasCategorias_CreateResponseDados {
despesa_categoria_id?: number
}

export type DespesasCategorias_CreateResponse = ApiResponse<DespesasCategorias_CreateResponseDados>;

registerResponseContract('DespesasCategorias_CreateResponse', {
  despesa_categoria_id: { type: 'number',  required: false },
})
